<template>
  <ul class="b-tabs-menu__wrapper" v-if="isShowTags">
    <li class="b-tabs-menu__item" @click="setFilter(0)">
      <div
        class="b-tabs-menu__button"
        :class="{ 'is-active': Number(this.getActiveFilter) === 0 }"
      >
        {{ this.getBundle.TITLE }}
      </div>
    </li>
    <li
      class="b-tabs-menu__item"
      v-for="(tag, index) in this.getTags"
      :key="index"
      @click="setFilter(index)"
    >
      <div
        class="b-tabs-menu__button"
        :class="{ 'is-active': Number(this.getActiveFilter) === Number(index) }"
      >
        {{ tag }}
      </div>
    </li>
  </ul>
</template>

<script>
import { useBundleStore } from "@/sleep_bundle/stores/bundle";
import { mapState } from "pinia";

export default {
  name: "BundlePoolTags",
  components: {},
  props: {
    number: Number,
  },
  setup() {
    const store = useBundleStore();

    return {
      store,
    };
  },
  methods: {
    setFilter(index) {
      this.store.setFilter(this.number, index);
    },
  },
  computed: {
    ...mapState(useBundleStore, ["getSelectedVariant"]),
    getBundle() {
      if (typeof this.getSelectedVariant !== "undefined") {
        let bundleId = Number(this.getSelectedVariant["POOL" + this.number]);

        return this.store.bundle[bundleId];
      }

      return [];
    },
    getProducts() {
      let productId = this.getBundle["PRODUCT"];

      return Object.values(this.store.product).filter((product) => {
        return productId.includes(Number(product.ID));
      });
    },
    isShowTags() {
      return this.getProducts.length >= 8;
    },
    getTags() {
      let data = {};
      for (const [, value] of Object.entries(this.getProducts)) {
        for (const [, tag] of Object.entries(value.TAGS)) {
          data[tag.ID] = tag.NAME;
        }
      }

      return data;
    },
    getActiveFilter() {
      return this.store.filter["pool" + this.number];
    },
  },
};
</script>
